// Entry: Svelte 5 app on top of the framework-free data Store (src/lib/store.ts).
import { mount } from 'svelte';
import './ui/theme.css';
import App from './ui/App.svelte';
import { app } from './lib/app.svelte';

app.setTheme(app.theme);
app.start();
mount(App, { target: document.getElementById('app')! });
